import classnames from 'classnames';
import { kebabCase } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { Row, Col, Button } from 'reactstrap';
const ReportActionRow = props => {
  const actionText = props.actionText,
    index = props.index,
    disabled = props.disabled,
    onAction = props.onAction;
  const handleAction = () => {
    onAction(actionText);
  };
  const marginStyle = index > 0 ? {
    marginTop: '20px'
  } : {};
  const buttonClass = classnames('form-control', "t-rar-button-".concat(kebabCase(actionText)));
  return /*#__PURE__*/React.createElement(Row, {
    style: marginStyle,
    key: "".concat(actionText, "Key")
  }, /*#__PURE__*/React.createElement(Col, {
    sm: {
      size: 10,
      offset: 1
    }
  }, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    className: buttonClass,
    disabled: disabled,
    onClick: handleAction
  }, actionText)));
};
ReportActionRow.propTypes = {
  actionText: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  // @TODO https://www.pivotaltracker.com/story/show/167581426
  // remove index in favor of css rule to adjust margin
  index: PropTypes.number.isRequired,
  onAction: PropTypes.func.isRequired
};
export default ReportActionRow;